import Quill from 'quill';

import {
  processLinkUrl,
  processMailToUrl,
} from 'hb-react/shared/components/DesignSystem/QuillEditor/utils/addLinkStyle';
import { getEmailRegex } from 'hb-react/shared/constants/emailRegex';
import { standardUrlRegex } from 'hb-react/shared/utils/validators/urlFormat';

const exactStandardUrlRegex = new RegExp(`^${standardUrlRegex.source}$`, 'i');
const exactEmailRegex = getEmailRegex({ global: false, mailto: 'optional' });

const InlineBlot = Quill.import('blots/inline');

class LinkBlot extends InlineBlot {
  static blotName = 'link';
  static tagName = 'A';

  static create(url) {
    const node = super.create();

    node.setAttribute('href', url);
    node.setAttribute('target', '_blank');
    node.setAttribute('title', node.textContent);

    return node;
  }

  static formats(domNode) {
    return domNode.getAttribute('href') || true;
  }

  format(name, value) {
    if (name === 'link' && value) {
      this.domNode.setAttribute('href', value);
    } else {
      super.format(name, value);
    }
  }

  formats() {
    const formats = super.formats();

    const href = LinkBlot.formats(this.domNode);
    const text = this.domNode.textContent;

    formats.link = href;

    if (exactStandardUrlRegex.test(text)) {
      formats.link = processLinkUrl(text);
    }

    if (exactEmailRegex.test(text)) {
      formats.link = processMailToUrl(text);
    }

    return formats;
  }
}

export default LinkBlot;
